import React, { useEffect, useState } from 'react';
import { CrmButton, CrmInput, CrmModal } from '../ui';

function CrmSaveViewModal({ open, onClose, onSave, entityLabel = 'contact' }) {
  const [label, setLabel] = useState('');

  useEffect(() => {
    if (open) setLabel('');
  }, [open]);

  const submit = (event) => {
    event.preventDefault();
    const nextLabel = label.trim();
    if (!nextLabel) return;
    onSave(nextLabel);
    onClose();
  };

  return (
    <CrmModal
      open={open}
      onClose={onClose}
      title={`Save ${entityLabel} view`}
      size="sm"
      footer={(
        <>
          <CrmButton onClick={onClose}>Cancel</CrmButton>
          <CrmButton variant="primary" type="submit" form="crm-save-contact-view" disabled={!label.trim()}>
            Save view
          </CrmButton>
        </>
      )}
    >
      <form id="crm-save-contact-view" onSubmit={submit}>
        <CrmInput
          label="View name"
          value={label}
          onChange={(event) => setLabel(event.target.value)}
          placeholder={`For example: Active ${entityLabel}s`}
          autoFocus
          maxLength={60}
        />
      </form>
    </CrmModal>
  );
}

export default CrmSaveViewModal;
